<template>
  <div class="reach">
    <div class="top clearfix">
      <div class="fl">
    
        <span></span><b style="font-weight:500;">触达渠道分析</b
        ><span class="text" style="color:#777;font-weight:400;">统计各个触达渠道的营销关键数值</span>
      </div>
      <!-- 右侧区域 -->
      <div class="fr">
        <p>
          <img src="../../assets/images/newIcon/ss_shaixuan_icon.png" alt="" />
          <el-select
            style="width: 100px"
            v-model="def"
            placeholder="请选择"
            class="my-select"
          >
            <el-option
              v-for="item in options1"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </p>
      </div>
    </div>
    <div class="card_box">
      <el-card shadow="never" class="my_card">
        <ul class="ul1">
          <li>
            <div class="left">
              <img src="../../assets/images/ticons/messege_icon@2x.png" alt="" />
              <p class="fz12">短信数据</p>
            </div>
            <div class="right">
              <ul class="ul2">
                <li>
                  <p class="top fz16">短信触达人数</p>
                  <p class="fz32">199<span class="fz16">人</span></p>
                </li>
                <li>
                  <p class="top">短信接收人数</p>
                  <p class="fz32">199<span class="fz16">人</span></p>
                </li>
                <li>
                  <p class="top">短信点击人数</p>
                  <p class="fz32">199<span class="fz16">人</span></p>
                </li>
                <li>
                  <p class="top">短信点击率</p>
                  <p class="fz32">48.9<span class="fz16">%</span></p>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div class="left">
              <img src="../../assets/images/ticons/wxgzh_icon@2x.png" alt="" />
              <p class="fz12">微信公众号</p>
            </div>
            <div class="right">
              <ul class="ul2">
                <li>
                  <p class="top fz16">触达人数</p>
                  <p class="fz32">199<span class="fz16">人</span></p>
                </li>
                <li>
                  <p class="top">接收人数</p>
                  <p class="fz32">199<span class="fz16">人</span></p>
                </li>
                <li>
                  <p class="top">点击人数</p>
                  <p class="fz32">199<span class="fz16">人</span></p>
                </li>
                <li>
                  <p class="top">点击率</p>
                  <p class="fz32">48.9<span class="fz16">%</span></p>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div class="left">
              <img src="../../assets/images/ticons/push_icon@2x.png" alt="" />
              <p class="fz12">push</p>
            </div>
            <div class="right">
              <ul class="ul2">
                <li>
                  <p class="top fz16">触达人数</p>
                  <p class="fz32">199<span class="fz16">人</span></p>
                </li>
                <li>
                  <p class="top">接收人数</p>
                  <p class="fz32">199<span class="fz16">人</span></p>
                </li>
                <li>
                  <p class="top">点击人数</p>
                  <p class="fz32">199<span class="fz16">人</span></p>
                </li>
                <li>
                  <p class="top">点击率</p>
                  <p class="fz32">48.9<span class="fz16">%</span></p>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </el-card>
      <el-card shadow="never" class="my_card">
        <!-- 顶部区域 -->
        <div class="fl">
          <img
            src="../../assets/images/newIcon/vipportrait_day_icon@2x.png"
            alt=""
          />
          <span></span><b style="font-weight:500;">近7日点击人数走势图</b>
        </div>
        <span class="text">2021.06.18 ～ 2021.07.20过去7天</span>
        <div id="z1" style="margin-top: 30px"></div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      def:'小橘帮帮',
      options1: [{ name: "小橘帮帮" },{ name: "颐安中台" }],
      data:[
        { data: "6.21", name: "短信", val: 740 },
        { data: "6.22", name: "短信", val: 750 },
        { data: "6.23", name: "短信", val: 850 },
        { data: "6.24", name: "短信", val: 760 },
        { data: "6.25", name: "短信", val: 600 },
        { data: "6.26", name: "短信", val: 750 },
        { data: "6.27", name: "短信", val: 580 },

        { data: "6.21", name: "微信公众号", val: 640 },
        { data: "6.22", name: "微信公众号", val: 650 },
        { data: "6.23", name: "微信公众号", val: 750 },
        { data: "6.24", name: "微信公众号", val: 660 },
        { data: "6.25", name: "微信公众号", val: 500 },
        { data: "6.26", name: "微信公众号", val: 650 },
        { data: "6.27", name: "微信公众号", val: 480 },

        { data: "6.21", name: "push", val: 540 },
        { data: "6.22", name: "push", val: 550 },
        { data: "6.23", name: "push", val: 650 },
        { data: "6.24", name: "push", val: 560 },
        { data: "6.25", name: "push", val: 400 },
        { data: "6.26", name: "push", val: 550 },
        { data: "6.27", name: "push", val: 380 },
      ]
    };
  },
  mounted(){
      this.init("z1",this.data,400)
  },
  methods: {
    init(id,data,height) {
      const chart = new this.$chart({
        container: id,
        autoFit: true,
        height: height || 320,
        padding: [10, 20, 65, 50],
      });
      chart.data(data);

      chart.scale({
        month: {
          range: [0, 1],
        },
        temperature: {
          nice: true,
        },
      });

      chart.scale("val", {
        min: 0,
        max: 1000,
      });
      chart
        .line()
        .position("data*val")
        .shape("smooth")
        .color("name", [
          "#5B8FF9",
          "#8D9FFC",
          "#9D6BFF",
        ]);
      chart.tooltip({
        showCrosshairs: false,
        shared: true,
        showMarkers: true, //移入图表展示圆点
      });

      // chart.point().position("data*val").shape("circle");

      chart.render();
    },
  },
};
</script>

<style lang="less">
.reach {
  padding: 20px;

  .top {
    margin-top: 15px;
    .fl {
      float: left;
      font-size: 16px;
      display: flex;
      b {
        margin-left: 6px;
      }
      img {
        width: 20px;
        height: 20px;
      }
      .text {
        margin-left: 12px;
        color: #333;
        font-size: 12px;
        line-height: 24px;
      }
    }
    .fr {
      float: right;
      color: #999999;
      font-size: 12px;
      margin-right: 25px;
      p {
        img {
          width: 16px;
          vertical-align: middle;
          //   margin-right: 10px;
        }
      }
      .my-select {
        margin-left: 10px;
      }
    }
  }
  .card_box {
    margin-top: 20px;
    .my_card {
      height: 700px;
      &:nth-child(1) {
        padding: 10px 30px;
        .ul1 {
          > li {
            height: 200px;
            margin-top: 20px;
            &:nth-child(1) {
              display: flex;
              .left {
                width: 91px;
                background-color: #8ac588;
                color: #fff;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                img {
                  width: 30px;
                  height: 30px;
                  margin-bottom: 5px;
                }
              }
              .right {
                flex: 1;
                background-color: #f3f8f1;
                .ul2 {
                  display: flex;
                  height: 100%;
                  align-items: center;
                  justify-content: space-around;
                  > li {
                    width: 97px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    .top {
                      margin-bottom: 5px;
                    }
                    &:before {
                      position: absolute;
                      right: -90px;
                      top: 27px;
                      content: "";
                      width: 1px;
                      height: 43px;
                      background-color: #d3d3d3;
                    }
                    &:last-child {
                      &:before {
                        background-color: transparent;
                      }
                    }
                  }
                }
              }
            }
            &:nth-child(2) {
              display: flex;
              .left {
                width: 91px;
                background-color: #688bee;
                color: #fff;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                img {
                  width: 30px;
                  height: 30px;
                  margin-bottom: 5px;
                }
              }
              .right {
                flex: 1;
                background-color: #f5f7fd;
                .ul2 {
                  display: flex;
                  height: 100%;
                  align-items: center;
                  justify-content: space-around;
                  > li {
                    width: 97px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    .top {
                      margin-bottom: 5px;
                    }
                    &:before {
                      position: absolute;
                      right: -90px;
                      top: 27px;
                      content: "";
                      width: 1px;
                      height: 43px;
                      background-color: #d3d3d3;
                    }
                    &:last-child {
                      &:before {
                        background-color: transparent;
                      }
                    }
                  }
                }
              }
            }
            &:nth-child(3) {
              background-color: blue;
              background-color: red;
              display: flex;
              .left {
                width: 91px;
                background-color: #ffb644;
                color: #fff;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                img {
                  width: 30px;
                  height: 30px;
                  margin-bottom: 5px;
                }
              }
              .right {
                flex: 1;
                background-color: #fff6e8;
                .ul2 {
                  display: flex;
                  height: 100%;
                  align-items: center;
                  justify-content: space-around;
                  > li {
                    width: 97px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    .top {
                      margin-bottom: 5px;
                    }
                    &:before {
                      position: absolute;
                      right: -90px;
                      top: 27px;
                      content: "";
                      width: 1px;
                      height: 43px;
                      background-color: #d3d3d3;
                    }
                    &:last-child {
                      &:before {
                        background-color: transparent;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      &:nth-child(2) {
        margin-top: 20px;
        height: 530px;
        // 顶部文字样式
        .fl {
          font-size: 16px;
          display: flex;
          align-items: center;
          b {
            margin-left: 10px;
          }
          img {
            width: 24px;
          }
        }
        .text {
          display: block;
          margin-left: 12px;
          color: #333;
          font-size: 12px;
          line-height: 24px;
          margin-top: 10px;
        }
      }
    }
  }
  //公共样式区
  .fz16 {
    font-size: 16px;
    
  }
  .fz32 {
    font-size: 32px;
    font-weight: bold;
  }
  .fz12 {
    font-size: 12px;
    font-weight: 400;
  }
}
</style>